import { render, staticRenderFns } from "./Istoric_programari.vue?vue&type=template&id=69df12ba&scoped=true"
import script from "./Istoric_programari.vue?vue&type=script&lang=js"
export * from "./Istoric_programari.vue?vue&type=script&lang=js"
import style0 from "./Istoric_programari.vue?vue&type=style&index=0&id=69df12ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69df12ba",
  null
  
)

export default component.exports